import { createContext } from 'react';

export const MobileAppValuesContext = createContext({});

export default MobileAppValuesContext;
